<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-white text-black border border-gray-300 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pb-0 pl-6">
            <!-- Logo -->
            <!-- <div class="flex items-center justify-center w-full mt-0">
                <img class="w-full" src="assets/icons/footer-logo.svg" />
            </div> -->
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4 pt-0 ">
            <!-- <div class="relative w-24 h-24">
                <img class="w-full h-full rounded-full" *ngIf="user.avatar || user.avatar!==''"
                    [src]=" imgPath + user.avatar" alt="User avatar" />
                <mat-icon class="icon-size-24" *ngIf="!user.avatar" [svgIcon]="'heroicons_solid:user-circle'">
                </mat-icon>
            </div> -->
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div
                    class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{ user.first_name + " " + user.last_name }}
                </div>
                <div
                    class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{ user.email }}
                </div>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <fuse-alert [appearance]="'outline'" [dismissible]="true" [dismissed]="true" [name]="'alert_success'"
        [type]="'success'" *ngIf="alertMessage">
        <span fuseAlertTitle>Success</span>
        {{ alertMessage }}
    </fuse-alert>

    <fuse-alert [appearance]="'outline'" [dismissible]="true" [dismissed]="true" [name]="'alert_error'"
        [type]="'error'">
        <span fuseAlertTitle>Error</span>
        {{ alertMessage }}
    </fuse-alert>
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-8 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- Google Translate -->
            <!-- <div id="google_translate_element"></div> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">{{ currentYear }} &copy; Myboeken.nl. All rights
            reserved.</span>
    </div> -->
</div>
